import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5284a0a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "quote" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("blockquote", null, [
        _createVNode(_component_font_awesome_icon, { icon: "fas fa-quote-left" }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.quote)) + " ", 1),
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("span", null, "— " + _toDisplayString(_ctx.author), 1)
      ]),
      _createVNode(_component_font_awesome_icon, { icon: "fas fa-quote-right" })
    ])
  ]))
}